import React, { Component } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextareaAutosize,
  Card,
  CardContent,
  Box,
  Typography,
  Tooltip,
  IconButton,
  TextField,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { userService } from "_services/user.service";
import { apiPath } from "api";
import { generalAuthTokenHeader } from "__helpers/auth-header";
import { PATIENT_LIST } from '__helpers/constants';
import OverallRiskPage from "./OverallRiskPage";
import riskIcon from '../../../assets/img/risk.svg';
import editBtn from '../../../assets/img/edit.png';
import css from '../../../assets/css/statuscard.css';
class StatusCard extends Component {
  constructor(props) {
    super(props);

    //const patientDetail = this.getPatientDetail();
    const patientDetail = this.getPatientDetail(props.patientId);
console.log("Last Name:", this.props.patientLastName);

    this.state = {
      status: patientDetail?.riskStatus ?? "",
      description: patientDetail?.aiSummary ?? "",
      isEditing: false,
      note: "",
      checked: patientDetail?.permanentlyOverride ?? false,
      showRiskModal: false, // ✅ new state for modal
      showRiskPage:false,
       aiSummary: [],
    };

    this.submitSurveyForm = this.submitSurveyForm.bind(this);
  }

  // ✅ Utility method to get patient data
  // ✅ Utility method to get patient data
  getPatientDetail = (patientIdFromProps) => {
    // If patientId is passed from props, prefer that
    let patientId = patientIdFromProps;
    console.log("👉 getPatientDetail called with patientIdFromProps:", patientIdFromProps);

    // Otherwise fallback to localStorage
    if (!patientId) {
      const patientData = localStorage.getItem("_selected_patient_list");
      patientId = patientData ? JSON.parse(patientData) : null;
      console.log("⚡ patientId from localStorage:", patientId);
    }

    if (!patientId) {
      console.log("❌ No patientId found");
      return null;
    }

    // Get the session patient list
    let sessionPatientList =
      JSON.parse(sessionStorage.getItem(PATIENT_LIST)) || [];
    console.log("📋 sessionPatientList:", sessionPatientList);

    // Find and return patient by id
    const patientDetail = sessionPatientList.find(
      (patient) => String(patient.patientId) === String(patientId)
    );

    console.log("✅ Matched patientDetail:", patientDetail);
    return patientDetail;
  };


  // ✅ loadStatus without props, uses getPatientDetail()
  loadStatus = () => {
    const patientDetail = this.getPatientDetail();

    this.setState({
      status: patientDetail?.riskStatus ?? "",
      description: patientDetail?.aiSummary ?? "",
      checked: patientDetail?.permanentlyOverride ?? false,
      note: "",
    });
  };

  // ✅ event handlers
  handleStatusChange = (e) => this.setState({ status: e.target.value });
  handleNoteChange = (e) => this.setState({ note: e.target.value });
  handleCheckbox = (e) => this.setState({ checked: e.target.checked });
  // toggleEdit = () => this.setState({ isEditing: true });
  // closeEdit = () => this.setState({ isEditing: false });

   closeEdit = () => {
  this.setState((prevState) => ({
    isEditing: false,
    status: prevState.originalStatus,
    note: prevState.originalNote,
    checked: prevState.originalChecked,
  }));
};


  // save current values
  openEdit = () => {
  this.setState((prevState) => ({
    isEditing: true,
    originalStatus: prevState.status,
    originalNote: prevState.note,
    originalChecked: prevState.checked,
  }));
};


  openRiskModal = () => {
    this.setState({ showRiskModal: true });
  };

  closeRiskModal = () => {
    this.setState({ showRiskModal: false });
  };

  componentDidMount() {
    this.checkTruncation();
    this.loadStatus(); // initial load
  }

  componentDidUpdate(prevProps, prevState) {
    // Get current patientId from localStorage
    const patientData = localStorage.getItem("_selected_patient_list");
    const currentPatientId = patientData ? JSON.parse(patientData) : null;

    const prevPatientData = localStorage.getItem("_prev_selected_patient_list");
    const prevPatientId = prevPatientData ? JSON.parse(prevPatientData) : null;

    if (currentPatientId !== prevPatientId) {
      console.log("🔄 PatientId changed in localStorage, reloading status");
      this.loadStatus();

      // update marker for next comparison
      localStorage.setItem("_prev_selected_patient_list", JSON.stringify(currentPatientId));
    }
  }


  // handleRiskSummaryClick = () => {
  //   this.setState({ showRiskPage: true });
  // };

  handleRiskSummaryClickClose = () => {
    this.setState({ showRiskPage: false });
  };

  checkTruncation = () => {
    if (this.descriptionRef) {
      const isTruncated =
        this.descriptionRef.scrollHeight > this.descriptionRef.clientHeight;

      // keep isTruncated independent of showRiskPage
      this.setState({ isTruncated });
    }
  };

  // handleRiskSummaryClick = () => {
  //   this.setState({ showRiskPage: true });
  // };

  handleRiskSummaryClickClose = () => {
    this.setState({ showRiskPage: false });
  };



  submitSurveyForm = async () => {
    this.setState({ loading: true });

    const patientData = localStorage.getItem("_selected_patient_list");
    const patientId = patientData ? JSON.parse(patientData) : null;

    const payload = {
      patientId: patientId,
      description: this.state.note,
      notesType: 0,
      permanentlyOverride: this.state.checked,
      riskstatus: this.state.status,
    };

    const apiUrl = apiPath.AddRiskStatusAndNotes;
    let showNotification = {};

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          ...generalAuthTokenHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      let responseBody;
      try {
        responseBody = await response.clone().json();
      } catch {
        responseBody = await response.text();
      }

      if (!response.ok) {
        showNotification = {
          title: responseBody.title || "Survey Error",
          message:
            responseBody.detail ||
            responseBody.message ||
            responseBody ||
            "Unknown error",
          type: "danger",
        };
      } else {
        showNotification = {
          title: responseBody.title || "Survey",
          message:
            responseBody.detail ||
            responseBody.message ||
            "Status updated successfully!",
          type: "success",
        };



        // ✅ Update sessionPatientList immediately
        let sessionPatientList =
          JSON.parse(sessionStorage.getItem(PATIENT_LIST)) || [];

        sessionPatientList = sessionPatientList.map((patient) =>
          String(patient.patientId) === String(patientId)
            ? {
              ...patient,
              riskStatus: this.state.status,
              aiSummary: this.state.description,
              permanentlyOverride: this.state.checked,
            }
            : patient
        );

        sessionStorage.setItem(PATIENT_LIST, JSON.stringify(sessionPatientList));

        // ✅ Reload state so UI reflects immediately
        this.loadStatus();

        // ✅ Reset form fields
        this.setState({
          isEditing: false,
          note: "",
          // checked: false,
        });
      }

      if (showNotification.title) {
        userService.showNotification(showNotification);
      }
    } catch (error) {
      console.error("Unexpected error submitting survey:", error);
      userService.showNotification({
        title: "Survey",
        message: error.message || "Server Error",
        type: "danger",
      });
    } finally {
      this.setState({ loading: false });
    }
  };
  async fetchAISummary() {
    const patientData = localStorage.getItem("_selected_patient_list");
    const patientId = patientData ? JSON.parse(patientData) : null;

    if (!patientId) {
      console.warn("No patient ID found in local storage.");
      this.setState({ aiSummary: [], aiSummaryLoaded: true });
      return;
    }

    const apiUrl = `${apiPath.GetAiSummary}?patientId=${patientId}`;

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });

      if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
        return;
      }

      const data = await response.json();

      if (response.ok) {
        if (!data || (Array.isArray(data) && data.length === 0)) {
          console.info("No AI summary available for this patient.");
        }

        this.setState({
          aiSummary: data || [],
          aiSummaryLoaded: true,
        });
      } else {
        console.warn("API response not OK", data);
        if (!data || !data.ok) {
          console.warn("API response not OK", data);

          // userService.showNotification({
          //   title: "",
          //   message: "No AI summary available for this patient.",
          //   type: "warning",
          // });
        }

        this.setState({ aiSummary: [], aiSummaryLoaded: true });
      }
    } catch (error) {
      console.error("Fetch error:", error);
      this.setState({ aiSummary: [], aiSummaryLoaded: true });
    }
  }

  handleRiskSummaryClick = async () => {
    try {
      await this.fetchAISummary();
      const { aiSummary } = this.state;

      const hasData =
        aiSummary &&
        (
          aiSummary.overallRisk ||
          aiSummary.summary ||
          aiSummary.detailed ||
          (Array.isArray(aiSummary.suggestions) && aiSummary.suggestions.length > 0) ||
          (Array.isArray(aiSummary.chart) && aiSummary.chart.length > 0) ||
          aiSummary.justification
        );

      if (hasData) {
        this.setState({ showRiskPage: true });
      } else {
        console.warn("No AI summary data found for this patient.");
        userService.showNotification({
          title: "",
          message: "No AI summary data available for this patient.",
          type: "info",
        });
        this.setState({ showRiskPage: false });
      }
    } catch (err) {
      // no need to notify again — fetchAISummary already did
      console.error("Error in fetchAISummary:", err);
      this.setState({ showRiskPage: false });
    }
  };


  render() {
    const { status, description, isEditing, note, checked } = this.state;
    return (
      <>

        {/* ✅ Default card view */}
        <Box
          display="flex"
          justifyContent="space-between"
        
          sx={{
            //width: 300, // reduced width
            height: '100%',
            backgroundColor: "#D4F0F0",
            borderRadius: 15,
            boxShadow: 1,
            alignItems: 'baseline',
            padding: "5px 5px 5px 15px",

          }}
        >
          <Box
            sx={{
              // width: 300,
              // height: '100%',
              // borderRadius: 15,
              // backgroundColor: "#D4F0F0",
              // boxShadow: 1,
            }}
          >
            <Box>
              <Typography className="risk-st" variant="subtitle2" fontWeight="bold" style={{ fontWeight: 600, color: "black" }}>
                <div>
  Risk Status :{" "}
  <span
    style={{
      color:
        status === "1"
          ? "red"
          : status === "2"
          ? "#FFD700"
          : status === "3"
          ? "green"
          : "black",
    }}
  >
    {status === "1"
      ? "High"
      : status === "2"
      ? "Medium"
      : status === "3"
      ? "Low"
      : "N/A"}
  </span>
  </div>
  {/* <Tooltip title="Edit">
            <IconButton size="small" onClick={this.toggleEdit} color="primary">
              <img src={ editBtn } alt="" srcset="" />
            </IconButton>
          </Tooltip> */}

          <Tooltip title="Edit">
    <IconButton
      size="small"
      onClick={this.openEdit} // ✅ updated here
      color="primary"
    >
      <img src={editBtn} alt="Edit" />
    </IconButton>
  </Tooltip>
</Typography>


              <Box>
               <Typography
               className="st-desc"
                  variant="caption"
                  color="text.secondary"
                  sx={{ mb: 0.5 }}
                  style={{color:'#424242', fontSize: '14px'}}
                >
                  {(() => {
                    const words = description ? description.split(" ") : [];
                    if (words.length <= 8) return description || "No description available";
                    return words.slice(0, 8).join(" ") + "...";
                  })()}
                </Typography>

                {description && ( 
                  <Typography
                    variant="caption"
                    color="primary"
                    sx={{ cursor: "pointer", fontWeight: "bold" }}
                    onClick={this.handleRiskSummaryClick}
                    style={{marginLeft: '10px', backgroundColor: '#F07DA8', color: '#ffffff', fontSize: '10px', borderRadius:50, padding:'3px 10px 3px 10px',cursor:'pointer', display:'inline-block'}}
                    className="see-more-button"
                  >
                    See more
                   
                  </Typography>
                  )}
                  


                    <OverallRiskPage
                      open={this.state.showRiskPage}
                      description={this.state.description}
                      patientId={this.props.patientId}
                      onClose={this.handleRiskSummaryClickClose}
                      patientLastName={this.props.patientLastName}
                      patientFirstName={this.props.patientFirstName}
                      patientMiddleName={this.props.patientMiddleName}
                      aiSummary={this.state.aiSummary}             // ✅ pass API data
                      aiSummaryLoaded={this.state.aiSummaryLoaded} // ✅ pass loading flag
                    />



              </Box>
            </Box>
          </Box>


          
        </Box >

        {/* ✅ Edit Dialog (bigger) */}
        < Dialog
          open={isEditing}
          maxWidth="sm"   // ⬅️ reduced dialog width
          fullWidth
          onClose={this.closeEdit}
          className="add-modal front-modal PatientStatusDialog"
          sx={{ "& .MuiDialog-paper": { maxWidth: 600 } }
          } // ⬅️ custom width control
        >
          <DialogTitle className="add-modal-title">
            Edit Risk Status
            <IconButton
              className="closeButton"
              aria-label="close"
              onClick={this.closeEdit}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            <FormControl fullWidth size="small" sx={{ mb: 2 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={status}
                onChange={(e) => this.setState({ status: e.target.value })}
                label="Status"
              >
                <MenuItem value="3">Low</MenuItem>
                <MenuItem value="2">Medium</MenuItem>
                <MenuItem value="1">High</MenuItem>
              </Select>
            </FormControl>

            {/* ✅ Proper way to increase note field height */}
            <TextField
              label="Note"
              value={note}
              onChange={(e) => this.setState({ note: e.target.value })}
              multiline
              fullWidth
              size="small"
              rows={8}     // ⬅️ fixed height (8 rows tall)
              minRows={8}  // ⬅️ ensures minimum height
              sx={{ mb: 2 }}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={(e) => this.setState({ checked: e.target.checked })}
                  color="primary"
                />
              }
              label="Permanently Override"
            />
          </DialogContent>

          <DialogActions>
            {/* <Button onClick={this.closeEdit} className="cancel-link">
              Cancel
            </Button> */}

            <Button onClick={this.closeEdit} className="cancel-link" style={{background: "#A9A9A9", height: '30px' }}>Cancel</Button>
            <Button
              onClick={this.submitSurveyForm}
              color="primary"
              variant="contained"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog >


      </>
    );
  }
}
export default StatusCard;
